var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-content"},[_c('h1',{staticClass:"title"},[_vm._v("成就平凡人的创业梦想")]),_c('img',{attrs:{"src":require("../../assets/down_bg.png"),"alt":"易伙伴app"}}),_c('div',{staticClass:"download-bottom"},[_c('van-button',{staticClass:"download-btn",attrs:{"type":"default"},on:{"click":_vm.download}},[_vm._v("下载易伙伴Pro")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }